module.exports = __webpack_public_path__ + "img/midBox_bg_dark.e9762803.png";